var _path, _ellipse, _path2, _ellipse2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare22BError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M20 22.5a2.5 2.5 0 0 1 2.5-2.5h15a2.5 2.5 0 0 1 2.5 2.5v15a2.5 2.5 0 0 1-2.5 2.5h-15a2.5 2.5 0 0 1-2.5-2.5v-15Z"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 30,
  cy: 12,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(90 30 12)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M24 13v-1c0-2.761 2.686-5 6-5s6 2.239 6 5v1"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 30,
  cy: 48,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(-90 30 48)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M36 47v1c0 2.761-2.686 5-6 5s-6-2.239-6-5v-1"
})));
SvgSquare22BError.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare22BError);
export default ForwardRef;